import { CreatedResponse, Job, JobForm } from "../types/types";
import { deleteRequest, get, post, put } from "../util/api";

/**
 * 全てのジョブを取得
 */
export const findAllJobs = async (): Promise<Job[]> => {
  return await get<Job[]>("/jobs");
};

/**
 * 年期でジョブを検索
 */
export const findJobsByNenki = async (nenki: string): Promise<Job[]> => {
  return await get<Job[]>("/jobs", { nenki });
};

export const createJob = async (jobForm: JobForm) => {
  jobForm.halfPeriod = "19A"; // FIXME
  jobForm.hikiai = Number(jobForm.hikiai);
  return await post<CreatedResponse>("/jobs", jobForm);
};

export const updateJob = async (jobForm: JobForm) => {
  jobForm.halfPeriod = "19A"; // FIXME
  jobForm.hikiai = Number(jobForm.hikiai);
  return await put<JobForm>("/jobs", jobForm);
};

export const deleteJob = async (id: number) => {
  return await deleteRequest(`/jobs/${id}`);
};
